export default {
    dependencies: ['$element', 'radio', 'geoservice', 'trackingservice'],
    callable(element, radio, geoservice, trackingservice) {
        const SORT_GEO = '99';
        const GEO_TIMEOUT = 5000;
        let previousValue = element.value;
        let latitude;
        let longitude;

        radio('filter-and-search-changed').subscribe(onFilterAndSearchChange);
        radio('geo-position-changed-from-filters').subscribe((lat, lon) =>
            onGeoPositionChange(lat, lon)
        );

        element.addEventListener('change', handleChange);

        onSortOverride();

        function onSortOverride() {
            const overrideSort = element.getAttribute('data-override-sort');
            if (overrideSort) {
                const lat = element.getAttribute('data-sort-lat');
                const lon = element.getAttribute('data-sort-lon');
                if (lat && lon) {
                    const url = new URL(document.baseURI);
                    url.searchParams.set('sort', SORT_GEO);
                    url.searchParams.set('lat', lat);
                    url.searchParams.set('lon', lon);
                    window.history.replaceState(
                        window.history.state,
                        '',
                        url.href
                    );
                }
            }
        }

        function onFilterAndSearchChange(filterAndSearch) {
            if (filterAndSearch && filterAndSearch.sortValues) {
                const sortedBy = filterAndSearch.sortValues.filter(
                    e => e.selected
                );
                if (sortedBy.length) {
                    element.value = sortedBy[0].value;
                }
            }
        }

        function onGeoPositionChange(lat, lon) {
            latitude = lat;
            longitude = lon;
        }

        function handleChange() {
            const value = element.value;

            if (value === SORT_GEO) {
                radio('geo-sort-initiated').broadcast();
                if (latitude && longitude) {
                    setSorting(value, latitude, longitude);
                } else {
                    geoservice
                        .getCurrentPosition({ timeout: GEO_TIMEOUT })
                        .then(geoSuccess.bind(null, value), geoError);
                }
            } else {
                setSorting(value);
            }
        }

        function geoSuccess(value, coords) {
            radio('geo-position-changed-from-sort').broadcast(
                coords.latitude,
                coords.longitude
            );
            setSorting(value, coords.latitude, coords.longitude);
        }

        function geoError() {
            element.value = previousValue;
            radio('geo-sort-failed').broadcast();
        }

        function setSorting(value, lat, long) {
            previousValue = value;
            const opts = {
                value,
                lat,
                long,
            };
            radio('sort-changed').broadcast(opts);
            trackingservice.trackEventObject({
                analyticsName: 'navigation.filter-by-sorting.click',
                stringValue: value,
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchSortSelect.js